import React, { memo } from "react";
import useStyles from "./styles";
import NoneData from "components/NoneData";
import HeaderMerchangdisingOrder from "./Components/HeaderMerchangdisingOrder";
import BodyMerchangdisingOrder from "./Components/BodyMerchangdisingOrder";
import FieldBody from "../FieldBody";
import moment from "moment";

import { Grid } from "@material-ui/core";

const formatDay = day => {
	return moment(day).format("DD/MM/YYYY");
};
const formatDayNotYear = day => {
	return moment(day).format("DD/MM");
};

const MerchangdisingHistoryOrder = memo(props => {
	const classes = useStyles();
	const { listOrder, isMobile, height } = props;

	const listOrderFormat = listOrder?.sort(function (a, b) {
		return new Date(b?.createTime) - new Date(a?.createTime);
	});

	return (
		<Grid classes={{ root: classes.root }} style={{ height: height }}>
			{!!listOrderFormat ? (
				listOrderFormat.map((product, index) => (
					<Grid classes={{ root: classes.history }} key={index}>
						<Grid classes={{ root: classes.historyItem }}>
							<HeaderMerchangdisingOrder product={product} />
							<Grid classes={{ root: classes.time }}>
								<Grid classes={{ root: classes.bodyTime }}>
									<FieldBody
										title="TG trưng bày"
										value={
											product?.startTimeMerchangdising
												? `${formatDayNotYear(
														product?.startTimeMerchangdising
												  )} - ${formatDay(
														product?.endTimeMerchandising
												  )}`
												: "--"
										}
									/>
									<FieldBody
										title="TG trả thưởng"
										value={
											product?.startTimeReward
												? `${formatDayNotYear(
														product?.startTimeReward
												  )} - ${formatDay(
														product?.endTimeReward
												  )}`
												: "--"
										}
									/>
								</Grid>
							</Grid>
							<BodyMerchangdisingOrder
								product={product}
								products={product?.items}
							/>
						</Grid>
					</Grid>
				))
			) : (
				<Grid
					classes={{ root: classes.centerPage }}
					style={{ height: isMobile ? height : 0 }}
				>
					<NoneData />
				</Grid>
			)}
		</Grid>
	);
});

export default MerchangdisingHistoryOrder;
